<template>
  <div class="Main">
    <v-container fluid>
      <v-row>
        <v-col align-self="center" align="center">
          <v-img :src="require('@/assets/ID_Blue.svg')" contain max-width="600" width="80%"/>
        </v-col>
      </v-row>
      <v-row class="px-10">
        <v-col align="center">
          <v-img :src="require('@/assets/smartphone.svg')" contain max-width="120" />
          <div class="py-5 text-uppercase font-weight-bold subtitle-2">Your personal ID is always in your control</div>
        </v-col>
        <v-col align="center">
          <v-img :src="require('@/assets/license.svg')" contain max-width="120" />
          <div class="py-5 text-uppercase font-weight-bold subtitle-2">You decide and allow who sees your personal information</div>
        </v-col>
        <v-col align="center">
          <v-img :src="require('@/assets/shield.svg')" contain max-width="120" />
          <div class="py-5 text-uppercase font-weight-bold subtitle-2">Our system is safe and secure</div>
        </v-col>
        <v-col align="center">
          <v-img :src="require('@/assets/sign.svg')" contain max-width="120" />
          <div class="py-5 text-uppercase font-weight-bold subtitle-2">ID4Good is so secure it can be a way to sign official documents and many more important actions to come</div>
        </v-col>
      </v-row>
      <v-row >
        <v-col align-self="center" align="center" class="font-weight title">
          ID4Good is one of the innovative features from Bloqs4Good. B4G is an ecosystem built on cutting edge technology, where an individuals privacy and personal information security is paramount. Our ecosystem4Good powers many wonderful experiences as well as helping SME's compete in the new economy coming.
        </v-col>
      </v-row>
      <v-row>
        <v-col align="center">
          <v-img :src="require('@/assets/google-play-badge.png')" contain max-width="300" />
        </v-col>
      </v-row>
      <v-row>
        <v-col align="center">
          <v-img :src="require('@/assets/apple-store-badge.svg')" contain max-width="265" />
        </v-col>
      </v-row>
      <v-row>
        <v-col align-self="center" align="center" class="comingsoon font-weight-bold display-3vue overline text-uppercase" style="font-size: 2rem !important">
          Coming soon
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import './_Main.scss'

export default {
  name: 'Main'
}
</script>
